import React from 'react';
import 'bootstrap/dist/js/bootstrap.bundle';
import {useEffect, useState} from "react";
import axiosClient from "../axios-client";
import Button from 'react-bootstrap/Button';
import { useStateContext } from "../contexts/ContentProvider";
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';

const MEMBERSHIP_TYPES = ['ride_membership', 'train_membership', 'align_membership'];

const hoursUntilClass = (classDate, classTime) => {
  const dt = new Date(`${classDate}T${classTime}`);
  return (dt - Date.now()) / 3_600_000;
};

const MisClases = () => {
  const [nextClasses, setIncoming] = useState([]);
  const [previousClasses, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getClasses();
  }, []);

  const getClasses = () => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem('USER_DATA'));
    const incomingPromise = axiosClient.get('/reservations/user/' + user.id)
      .then(({ data }) => {
        setIncoming(data);
      })
      .catch((e) => {
        console.log(e)
      });
  
    const historyPromise = axiosClient.get('/reservations/user/history/' + user.id)
      .then(({ data }) => {
        setHistory(data.data);
      })
      .catch((e) => {
        console.log(e)
      });
  
    Promise.all([incomingPromise, historyPromise])
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const cancelarRes = (res) => {
    swal("¿Esta seguro de cancelar su reservacion el: "+res.class_date+" a las: "+res.class_time+"?", 
    {
      dangerMode: true,
      buttons: true,
    }).then(result => {
      if (result) {
        setLoadingCancel(true);
        axiosClient
          .put('/reservations/'+res.id)
          .then(({ data }) => {
            if(data.confirmation) {
              swal({
                title: "Confirmacion",
                text: data.confirmation,
                icon: "warning",
                buttons: ["Cancelar", "Confirmar"],
              }).then((result) => {
                if (result) {
                  confirmacionCancel(res.id);
                } else {
                  setLoadingCancel(false);
                }
              });
            } else {
              swal({
                title: "Cancelación Exitosa",
                text: "El crédito de su clase se volvio a abonar al paquete de clases correspondiente",
                icon: "success",
              }).then(() => {
                window.location.reload();
              });
              setLoadingCancel(false);
            }
          })
          .catch((error) => {
            const err = JSON.parse(error.request.response);
            swal({
              title: "Error",
              text: err.message,
              icon: "error",
            })
            setLoading(false);
          });
      }
    });
  }

  const confirmacionCancel = (id) => {
    axiosClient
      .put('reservations/'+id+'/cancel?confirmCancellation=true')
      .then(({data}) => {
        swal({
          title: "Cancelación Exitosa",
          text: "Se libero el asiento de su clase.",
          icon: "success",
        }).then(() => {
          window.location.reload();
        });
        setLoadingCancel(false);
      }).catch((error) => {
        console.log(error)
        setLoadingCancel(false);
      })
  }
  
  return (
    <div className='container '>
      <div className='datos-container'>
        <p className='semi-bold'>Próximas Clases</p>
        <hr></hr>
          {loading ? (
            <div className='loading-container center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
          ) : (
            !nextClasses ? (
              <p className='bold ms-4'>No tienes clases pronto</p>
            ) : (
              <div className='table-responsive'>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Clase</th>
                      <th>Hora</th>
                      <th>Coach</th>
                      <th>Lugar</th>
                      <th>Estatus</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {nextClasses.map((data) => (
                      <tr key={data.id}>
                        <td>{data.class_date}</td>
                        <td>{data.type_class}</td>
                        <td>{data.class_time}</td>
                        <td>{data.coach}</td>
                        <td>{data.bike_number}</td>
                        <td>{data.status}</td>
                        <td>
                          {(() => {
                            const isMem = MEMBERSHIP_TYPES.includes(data.package_type);
                            const hoursLeft = hoursUntilClass(data.class_date, data.class_time);
                            const blocked = isMem && hoursLeft < 10;
                            if (blocked) {
                              return (
                                <Button
                                  variant="outline-info"
                                  size="sm"
                                  onClick={() => swal({
                                    title: 'Cancelación no disponible',
                                    text: 'Las reservas con membresía solo se pueden cancelar con 10 horas o más de anticipación. Los paquetes de créditos permiten cancelar hasta 5 horas antes.',
                                    icon: 'info',
                                  })}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                  </svg>
                                </Button>
                              );
                            }
                            return (
                              <Button
                                variant="secondary"
                                disabled={loadingCancel}
                                onClick={() => cancelarRes(data)}
                              >
                                Cancelar
                              </Button>
                            );
                          })()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}
      </div>


      <div className='datos-container'>
        <p className='semi-bold'>Historial de Clases</p>
        <hr></hr>
        {loading ? (
            <div className='loading-container center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
          ) : (
            !previousClasses ? (
              <p>No tiene historial de clases</p>
            ) : (
              <div className='table-responsive'>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Clase</th>
                      <th>Hora</th>
                      <th>Coach</th>
                      <th>Lugar</th>
                      <th>Estatus</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previousClasses.map((data) => (
                      <tr key={data.id}>
                        <td>{data.class_date}</td>
                        <td>{data.type_class}</td>
                        <td>{data.class_time}</td>
                        <td>{data.coach}</td>
                        <td>{data.bike_number}</td>
                        <td>{data.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}
      </div>
    </div>
  );
};

export default MisClases;